import { Component } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { TerritoriesService } from '../../../../services/TerritoriesService.service';
import { TutorialService } from 'src/app/features/ui/organisms/tutorial/services/tutorial.service';
import { MapHelperService } from 'src/services/map-helper.service';

@Component({
  selector: 'app-territories-section',
  templateUrl: './territories-section.component.html',
  styleUrls: ['./territories-section.component.css']
})
export class TerritoriesSectionComponent {

  public _isVisiblePanelTerritories: boolean = false;
  public _isVisiblePanelEditTerritories: boolean = false;
  public _isVisiblePanelDetailTerritories: boolean = false;
  
  private $isVisiblePanelTerritories: Observable<boolean>;
  private $isVisiblePanelEditTerritories: Observable<boolean>;
  private $isVisiblePanelDetailTerritories: Observable<boolean>;
  
  subscription_GetLoading: Subscription;
  subscription_SetLocationsGeoJson: Subscription;
  subscription_checkAuthenticated: Subscription;
  isVisiblePanelTerritories: Subscription;
  isVisiblePanelAddTerritories: Subscription;
  isVisiblePanelEditTerritories: Subscription;
  isVisiblePanelDetailTerritories: Subscription;
  isAdmin: any;

  constructor(
    private territoriesService: TerritoriesService,
    private tutorialService: TutorialService,
    private mapHelperService: MapHelperService
  ) {
    this.$isVisiblePanelTerritories = this.territoriesService.getVisiblePanelTerritories();
    this.isVisiblePanelTerritories = this.$isVisiblePanelTerritories.subscribe((data) => {
      this._isVisiblePanelTerritories = data;
      console.log("territories", this._isVisiblePanelTerritories);
      
      setTimeout(() => {
        if (this._isVisiblePanelTerritories != undefined && this._isVisiblePanelTerritories == true) {
          this.tutorialService.startTutorial(["panelTerritoriesTutorial"]);
        }
      }, 1000);
    });

    this.$isVisiblePanelEditTerritories = this.territoriesService.getVisiblePanelEditTerritories();
    this.isVisiblePanelEditTerritories = this.$isVisiblePanelEditTerritories.subscribe((data) => {
      this._isVisiblePanelEditTerritories = data;
    });

    this.$isVisiblePanelDetailTerritories = this.territoriesService.getVisiblePanelDetailTerritories();
    this.isVisiblePanelDetailTerritories = this.$isVisiblePanelDetailTerritories.subscribe((data) => {
      this._isVisiblePanelDetailTerritories = data;
      console.log("detail", this._isVisiblePanelDetailTerritories);
      
      setTimeout(() => {
        if (this._isVisiblePanelDetailTerritories != undefined && this._isVisiblePanelDetailTerritories == true) {
          this.tutorialService.startTutorial(["panelTerritoriesDetailTutorial"]);
        }
      }, 1000);
    });
  }

  ngOnInit(): void {
    this.mapHelperService.mapResize();
  }

  ngOnDestroy() {
    if (this.subscription_SetLocationsGeoJson)
      this.subscription_SetLocationsGeoJson.unsubscribe();
    if (this.subscription_GetLoading)
      this.subscription_GetLoading.unsubscribe();
    if (this.subscription_checkAuthenticated)
      this.subscription_checkAuthenticated.unsubscribe();
    if (this.isVisiblePanelTerritories)
      this.isVisiblePanelTerritories.unsubscribe();
    if (this.isVisiblePanelAddTerritories)
      this.isVisiblePanelAddTerritories.unsubscribe();
    if (this.isVisiblePanelEditTerritories)
      this.isVisiblePanelEditTerritories.unsubscribe();
    if (this.isVisiblePanelDetailTerritories)
      this.isVisiblePanelDetailTerritories.unsubscribe();
  }

}
